//REGISTER USER
import axios from 'axios';
import setAuthToken from '../../utils/setAuthToken';
import jwt_decode from 'jwt-decode';
import {
    AUTH_ALERT,
    AUTH_ERRORS,
    AUTH_PASSWORD_RESET_TOKEN,
    FORGOT_PASSWORD,
    AUTH_MUTLTIFACTOR_MESSAGE,
    GET_API_KEY,
    GET_CURRENT_USER,
    AUTH_ERROR,
    GET_USERS,
    GET_ERRORS,
    SET_CURRENT_USER,
    USER_QLIK_TICKET,
    USERS_LOADING,
    AUTH_EMAIL_VERIFIED,
    SHOW_SUBSCRIPTION,
    SHOW_SUBSCRIPTION_WITH_USER,
    SHOW_PAYMENT,
    SHOW_REGISTRATION,
    SET_SELECTED_PRODUCT,
    SHOW_PAYMENT_SUCCESS,
    AUTH_GET_PRICING_CARDS,
    AUTH_UPDATING_TOKEN,
    LOGIN_FLAG,
    REDIRECT_URL,
} from './types';
import { ToastsStore } from 'react-toasts';
import moment from 'moment';
import store from '../store';
import { find } from 'lodash';
import { saasRequest } from 'websockets/utils/SaaSUtils';
import api from 'api';
import { qsServerSelector } from 'redux/qsServer/selector';
import {history} from 'App';

/***
 * @const createUserAction
 * @param userData : User Registration Data passed form /register
 * @param history : React Redirect Property to be used on registration success
 * @returns {Function} : A redirect to the /settings/users or some errors to be displayed on fail
 */
export const createUserAction = (userData, history) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post('/api/users/create', userData)
        .then(() => {
            ToastsStore.success(
                'Account created successfully, please as user to login.'
            );
            history.push('/settings/users');
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

/***
 * @const registerUserAction
 * @param userData : User Registration Data passed form /register
 * @param history : React Redirect Property to be used on registration success
 * @returns {Function} : A redirect to the /settings/users or some errors to be displayed on fail
 */
export const registerUserAction = (userData, history) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post('/api/users/register', userData)
        .then((res) => {
            ToastsStore.success(
                'Account created successfully, please as user to login.'
            );
            history.push('/settings/users');
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

// const hasOrg = () => store.getState().auth.user.org || store.getState().organisation.selectedOrgId
const isAdmin = () => store.getState().auth.user.role === 'Admin';
const isOrgAdmin = () => store.getState().auth.user.role === 'OrgAdmin';
const getOrg = () =>
    store.getState().organisation.selectedOrgId ??
    store.getState().auth.user.org;

export const getUsers = () => (dispatch) => {
    let url = '/api/users';

    axios
        .get(url)
        .then((res) => {
            dispatch({
                type: GET_USERS,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const getOrgUsers = (orgId) => (dispatch) => {
    dispatch(setAuthLoading());
    let url = '/api/users';
    url += `/org/${orgId}/`;
    if (isAdmin || (isOrgAdmin && orgId === getOrg())) {
        axios
            .get('/api/orgs')
            .then((res) => {
                const orgs = res.data;

                axios
                    .get(url)
                    .then((res) => {
                        dispatch({
                            type: GET_USERS,
                            payload: res.data.map((u) =>
                                u.organisation
                                    ? {
                                          ...u,
                                          orgName: find(orgs, {
                                              _id: u.organisation,
                                          }).name,
                                      }
                                    : u
                            ),
                        });
                    })
                    .catch((err) => {
                        dispatch(authErrors(err));
                    });
            })
            .catch((err) => {
                dispatch(authErrors(err));
            });
    } else {
        dispatch({
            type: GET_USERS,
            payload: null,
        });
    }
};

export const forgotPassword = (userData) => (dispatch) => {
    dispatch(setAuthLoading());

    axios
        .post('/api/users/forgot-password-email', userData)
        .then(() => {
            dispatch({
                type: FORGOT_PASSWORD,
                payload: 'success',
            });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const exitForgotPassword = () => (dispatch) => {
    dispatch(setAuthLoading());
    dispatch({
        type: FORGOT_PASSWORD,
        payload: null,
    });
};

export const checkPasswordResetToken = (token) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .get(`/api/users/validate-password-token/${token}`)
        .then((res) => {
            const passwordToken = res.data.changePasswordRequest;
            const tokenExpDate = moment(passwordToken.date).add(2, 'hours');
            const now = moment();

            if (tokenExpDate > now) {
                //Valid Token
                dispatch({ type: AUTH_PASSWORD_RESET_TOKEN, payload: true });
            } else {
                //Invalid Token
                dispatch({ type: AUTH_PASSWORD_RESET_TOKEN, payload: false });
            }
        })
        .catch((err) => {
            dispatch(authErrors(err));
            dispatch({ type: AUTH_PASSWORD_RESET_TOKEN, payload: false });
        });
};

export const authVerifyEmail = (email, token) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .put(`/api/users/verify_email`, { email, token })
        .then((res) => {
            dispatch({ type: AUTH_EMAIL_VERIFIED, payload: true });
        })
        .catch((err) => {
            dispatch(authErrors(err));
            dispatch({ type: AUTH_EMAIL_VERIFIED, payload: false });
        });
};

export const authSetNewPassword = (data, history) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post(`/api/users/new-password-with-token/${data.token}`, data)
        .then((res) => {
            ToastsStore.success('Password updated successfully,  please login');
            history.push('/login');
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const logMeIn =
    (history = null, redirectUrl = null) =>
    async (dispatch, getState) => {
        const state = getState();
        const { tenantUri, webIntegrationId } = qsServerSelector(state);

        try {
            const user = await saasRequest(
                tenantUri,
                '/api/v1/users/me',
                webIntegrationId
            );
            api.auth.saas
                .login(user)
                .then((result) => {
                    const { success, token } = result;
                    if (success) {
                        dispatch(completeAuthLogin(token));
                    }
                    if (history && redirectUrl) {
                        history.push(redirectUrl);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            const returnTo = encodeURIComponent(window.location.href);
            window.location.href = `${tenantUri}/login?returnto=${returnTo}&qlik-web-integration-id=${webIntegrationId}`;
        }
    };

export const completeLogin = (token, dispatch) => {
    localStorage.setItem('jwtToken', token);

    //SET TOKEN TO AUTH HEADER
    setAuthToken(token);

    //DECODE TOKEN TO GET USER
    const decoded = jwt_decode(token);

    //SET CURRENT USER
    dispatch(setCurrentUser(decoded));

    dispatch(setLoginFlag(true));

    gotoLandingPage();
};

const gotoLandingPage = () => {
    api.pages
        .getLandingPage()
        .then((page) => {
            if (page) {
                history.push(`/pages/${page.id}`);
            }
            window.location.reload(false);
        })
        .catch((err) => {
            console.error(err);
            window.location.reload(false);
        });
};

export const setLoginFlag = (payload) => (dispatch) => {
    dispatch({ type: LOGIN_FLAG, payload });
};

export const setRedirectUrl = (payload) => (dispatch) => {
    dispatch({ type: REDIRECT_URL, payload });
};

export const completeAuthLogin = (token) => (dispatch) => {
    localStorage.setItem('jwtToken', token);

    //SET TOKEN TO AUTH HEADER
    setAuthToken(token);

    //DECODE TOKEN TO GET USER
    const decoded = jwt_decode(token);

    //SET CURRENT USER
    dispatch(setCurrentUser(decoded));

    gotoLandingPage();
};

export const validateLogin = (userData) => (dispatch) => {
    dispatch(setAuthLoading());

    axios
        .post('/api/users/validate-login', userData)
        .then((res) => {
            //SAVE TO LOCAL STORAGE
            const { token } = res.data;
            if (token) {
                completeLogin(token, dispatch);
            }
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const getPricing = () => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .get('/api/subscription/pricing')
        .then((res) => {
            dispatch({ type: AUTH_GET_PRICING_CARDS, payload: res.data });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const createPricing = (pricing, history) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post('/api/subscription/pricing/create', pricing)
        .then((res) => {
            dispatch({ type: AUTH_GET_PRICING_CARDS, payload: res.data });
            ToastsStore.success('Pricing created successfully');
            history.push('/settings/pricing');
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const updatePricing = (pricing, history) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post(`/api/subscription/pricing/update/${pricing._id}`, pricing)
        .then((res) => {
            dispatch({ type: AUTH_GET_PRICING_CARDS, payload: res.data });
            ToastsStore.success('Pricing updated successfully');
            history.push('/settings/pricing');
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const deletePricing = (pricing) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .delete(`/api/subscription/pricing/delete/${pricing}`)
        .then((res) => {
            dispatch({ type: AUTH_GET_PRICING_CARDS, payload: res.data });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

/**
 * @const loginUser
 * @param userData : User Login Data passed in form /login
 * @param history : React redirect property to be used on login success
 * @returns {Function} Setting token in local storage and returning errors on failure
 */
export const loginUser = (userData, history) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post('/api/users/login', userData)
        .then((res) => {
            const { token, message, success } = res.data;

            if (!success) {
                // hijacked here because email verification is incomplete
                ToastsStore.warning(message);
                history.push(`/verify/emailSent?email=${userData.email}`);
            }
            if (token) {
                return completeLogin(token, dispatch);
            }
            if (message) {
                return dispatch({
                    type: AUTH_MUTLTIFACTOR_MESSAGE,
                    payload: message,
                });
            }
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const getCurrentUser = () => (dispatch) => {
    dispatch(setUsersLoading());
    axios
        .get('/api/users/current')
        .then((res) => {
            dispatch({
                type: GET_CURRENT_USER,
                payload: res.data,
            });
        })
        .catch((err) => {
            err?.response?.data &&
                dispatch({
                    type: GET_ERRORS,
                    payload: err.response.data,
                });
        });
};

export const updateAuthTokenAction = () => (dispatch) => {
    dispatch(setAuthLoading());
    const jwtToken = localStorage.getItem('jwtToken');

    if (jwtToken) {
        const { exp } = jwt_decode(jwtToken);
        const currentTime = (Date.now() / 1000).toFixed(0);
        const timeRemaining = exp - currentTime;

        if (timeRemaining < 600) {
            axios
                .post('/api/users/update-token', { token: jwtToken })
                .then((res) => {
                    //SAVE TO LOCAL STORAGE
                    const { token } = res.data;
                    if (token) {
                        localStorage.setItem('jwtToken', token);

                        //SET TOKEN TO AUTH HEADER
                        setAuthToken(token);

                        //DECODE TOKEN TO GET USER
                        const decoded = jwt_decode(token);

                        //SET CURRENT USER
                        dispatch(setCurrentUser(decoded));
                    }
                })
                .catch((err) => {
                    dispatch(logoutUser());
                });
        }
    }
};

export const logoutUser =
    (redirectUrl = null) =>
    (dispatch) => {
        axios
            .post('/api/users/logout', {})
            .then(() => {
                localStorage.removeItem('jwtToken');
                setAuthToken(false);
                if (redirectUrl) dispatch(setRedirectUrl(redirectUrl));
                dispatch(setCurrentUser({}));
            })
            .catch((err) => {
                localStorage.removeItem('jwtToken');
                setAuthToken(false);
                dispatch(setCurrentUser({}));
                dispatch(authErrors(err));
            });
    };

//SET LOGGED IN USER
export const setCurrentUser = (decoded) => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded,
    };
};

export const qlikLoginSSO = (auth) => (dispatch) => {
    const user = auth.user;
    const { userId, userDir } = user;
    axios
        .post('/api/users/qlik-node-sso', { userId, userDir })
        .then((res) => {
            const qTicket = res.data.qTicket;
            localStorage.setItem('qTicket', qTicket);
            dispatch({
                type: USER_QLIK_TICKET,
                payload: res.data.qTicket,
            });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const setAuthLoading = () => {
    return {
        type: USERS_LOADING,
    };
};

export const getAlert = () => (dispatch) => {
    axios
        .get('/api/settings/alert')
        .then((res) => {
            dispatch({
                type: AUTH_ALERT,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const getApiKey = () => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .get('/api/users/api-key')
        .then((res) => {
            dispatch({
                type: GET_API_KEY,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const authErrors = (errors) => (dispatch) => {
    if (errors && errors?.response?.data) {
        dispatch({
            type: AUTH_ERRORS,
            payload: errors.response.data,
        });
    } else {
        throw new Error(errors);
    }
};

export const registerUserWithStripe = (user, dispatch) => {
    return axios
        .post('/api/subscription/create_customer', user)
        .then((res) => {
            dispatch({
                type: SHOW_SUBSCRIPTION_WITH_USER,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const completeSubscription = () => (dispatch) => {
    dispatch({ type: SHOW_SUBSCRIPTION });
};

/***
 * @const registerUser
 * @param userData : User Registration Data passed form /register
 * @param history : React Redirect Property to be used on registration success
 * @returns {Function} : A redirect to the /login or some errors to be displayed on fail
 */
export const authRegister = (userData) => (dispatch) => {
    dispatch(setAuthLoading());
    return axios
        .post('/api/users/register', userData)
        .then((res) => {
            ToastsStore.success('Account created successfully.');
            localStorage.setItem('coeus-signup-email', res.data.email);
            registerUserWithStripe(res.data, dispatch);
        })
        .catch((err) => {
            dispatch(authErrors(err));
        });
};

export const selectSubscription =
    (product, email = null) =>
    (dispatch) => {
        if (!email) {
            email = localStorage.getItem('coeus-signup-email');
        }
        dispatch({ type: SET_SELECTED_PRODUCT, payload: product });
        return axios
            .put('/api/users/update_subscription', {
                email,
                type: product.type,
            })
            .then((user) => {
                dispatch({
                    type: SHOW_PAYMENT,
                    payload: user,
                });
            })
            .catch((err) => {
                ToastsStore.error(
                    'There has been an error in the system. Please try again'
                );
            });
    };

export const showRegisterUser = () => (dispatch) => {
    dispatch({
        type: SHOW_REGISTRATION,
    });
};

const handleCustomerActionRequired = ({
    subscription,
    invoice,
    priceId,
    paymentMethodId,
    isRetry,
    dispatch,
    stripe,
}) => {
    if (subscription && ['active', 'trialing'].includes(subscription.status)) {
        return { subscription, priceId, paymentMethodId, dispatch };
    }

    const paymentIntent = invoice
        ? invoice.payment_intent
        : subscription.latest_invoice.payment_intent;

    if (
        paymentIntent.status === 'requires_action' ||
        (isRetry === true && paymentIntent.status === 'requires_payment_method')
    ) {
        return stripe
            .confirmCardPayment(paymentIntent.client_secret, {
                payment_method: paymentMethodId,
            })
            .then((result) => {
                if (result.error) {
                    throw result;
                }
                if (result.paymentIntent.status === 'succeeded') {
                    return {
                        priceId,
                        subscription,
                        invoice,
                        paymentMethodId,
                        dispatch,
                    };
                }
            });
    }

    return { subscription, priceId, paymentMethodId, dispatch };
};

const handlePaymentMethodRequired = ({
    subscription,
    paymentMethodId,
    priceId,
    dispatch,
}) => {
    if (['active', 'trialing'].includes(subscription.status)) {
        return { subscription, priceId, paymentMethodId, dispatch };
    }

    if (
        subscription.latest_invoice.payment_intent.status ===
        'requires_payment_method'
    ) {
        localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
        localStorage.setItem(
            'latestInvoicePaymentIntentStatus',
            subscription.latest_invoice.payment_intent.status
        );
        axios.get(
            `/api/subscription/send_subscription_failure_email/failed_initial_payment/${localStorage.getItem(
                'coeus-signup-email'
            )}`
        );
        throw new Error({ error: { message: 'Your card was declined.' } });
    }
    return { subscription, priceId, paymentMethodId, dispatch };
};

const onSubscriptionComplete = (result) => {
    if (['active', 'trialing'].includes(result.subscription.status)) {
        result.dispatch({ type: SHOW_PAYMENT_SUCCESS });
    }
    axios.get(
        `/api/subscription/send_subscription_success_email/${localStorage.getItem(
            'coeus-signup-email'
        )}`
    );
};

export const performPayment =
    (paymentMethod, stripe, email = null) =>
    (dispatch) => {
        if (!email) {
            email = localStorage.getItem('coeus-signup-email');
        }
        return axios
            .post('/api/subscription/make_payment', { paymentMethod, email })
            .then((res) => {
                const { stripeSubscription } = res.data;
                return {
                    paymentMethodId: paymentMethod,
                    priceId: stripeSubscription.plan.id,
                    subscription: stripeSubscription,
                    dispatch,
                    stripe,
                };
            })
            .then(handleCustomerActionRequired)
            .then(handlePaymentMethodRequired)
            .then(onSubscriptionComplete)
            .catch((err) => {
                dispatch(authErrors(err));
                ToastsStore.error(
                    'There has been an error with your payment. Please try again'
                );
            });
    };

export const resetErrors = () => (dispatch) => {
    return dispatch({ type: AUTH_ERROR, payload: null });
};

export const setUsersLoading = () => (dispatch) => {
    return dispatch({ type: USERS_LOADING, payload: true });
};

export const changeProductSelection = () => (dispatch) => {
    dispatch({
        type: SHOW_SUBSCRIPTION,
    });
};
